import React from 'react';
import { ItemNumberValue } from 'components/project/AuctioneerScreen';
import styled from 'styled-components';

const Container = styled.div`
  grid-area: lotNumber;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: #931C11;
  & h1 {
    margin: 0;
    color: #fff;
    font-size: min(4vw, 5em);
  }
`;

const ItemNumberContainer = () => {
  return (
    <Container>
      <ItemNumberValue />
    </Container>
  );
};

export default ItemNumberContainer;
